<div *ngIf="isOpen" [@fadeInOut] role="dialog" aria-modal="true">

  <div class="drawer-container pt-3" [@slideInOut] (click)="$event.stopPropagation()">
    <div class="d-flex gap-1 cursor" (click)="onClose()">
      <img src="../../../../assets/images/playback-analysis-drawer-close.svg" alt="" class="img-fluid">
      <span class="playback-analysis-label">Analysis</span>
    </div>
    <div class="mt-3">
      <div class="playback-v2-stat-title-chassis">Vehicle Chassis Number</div>
      <div class="playback-v2-stat-value-chassis">{{ entityName }} </div>
    </div>

    <div class="data-toggle-container">
      <div class="toggle-switch-pill">
        <button class="toggle-option" [class.active]="isTableViewActive()" (click)="setActiveView('table')"
          aria-label="Switch to Table View">
          <img src="../../../../assets/images/table-toggle-icon.svg" alt="" class="img-fluid"
            *ngIf="isTableViewActive()">
          <img src="../../../../assets/images/table-toggle-icon-inactive.svg" alt="" class="img-fluid"
            *ngIf="!isTableViewActive()">
        </button>

        <button class="toggle-option" [class.active]="isChartViewActive()" (click)="setActiveView('chart')"
          aria-label="Switch to Chart View">
          <img src="../../../../assets/images/chart-toggle-icon.svg" alt="" class="img-fluid"
            *ngIf="isChartViewActive()">
          <img src="../../../../assets/images/chart-toggle-icon-inactive.svg" alt="" class="img-fluid"
            *ngIf="!isChartViewActive()">
        </button>
      </div>

      <div class="data-content">
        <div *ngIf="isTableViewActive()" class="table-view">
          <div class="mt-3">
            <div class="d-flex gap-10">
              <span class="table-title">Real-time Vehicle Telemetry Trails </span>
              <span class="data-point-count-text">{{ transformedAttributeData?.length }} data points </span>
            </div>
            <app-common-table [columnHeader]="telemetryColumHeader" [tableData]="telemetryTableData"
              [tableTitle]="'Telemetry Data'" pageType="geoTraceTelemetry"
              [actionPermission]="{pagination : false}"></app-common-table>
          </div>
          <div class="mt-3">
            <div class="d-flex gap-10">
              <span class="table-title">Alert List</span>
              <div class="position-relative"><img src="../../../../assets/images/bell-icon-new.svg"
                  [ngClass]="activeAlertsCount ? 'bell-icon-filter' : ''" alt="" class="img-fluid h-80">
              </div><sup class="alert-count" *ngIf="activeAlertsCount > 0">{{ activeAlertsCount ? activeAlertsCount :
                0
                }}</sup>
            </div>
            <app-common-table [columnHeader]="alertColumnHeader" [tableData]="alertsHighlighted" [tableTitle]="'Alerts'"
              pageType="geoTraceAlert" (selectedAlert)="selectedAlertUpdate($event)" [hasStickyHeader]="true"
              [actionPermission]="{pagination : false}"></app-common-table>
          </div>
        </div>

        <div *ngIf="isChartViewActive()" class="chart-view">
          <div class="chart-box">
            <div class="chart-type-dropdown">
              <mat-form-field appearance="outline">
                <mat-select [formControl]="chartType" panelClass="multiSelectPanel" placeholder="Chart Type"
                  class="-mat-select-mt-0" (selectionChange)="onChartTypeChange($event)">
                  <mat-option *ngFor="let item of chartTypes" [value]="item?.value">
                    {{ item.name | titlecase }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <app-chart-builder [entityDetails]="{_id: entityId}" class="h-100" [hideStatistics]="true" [pageType]="'playback-v2'"
              [selfServiceChartAttributes]="chartAttributes"></app-chart-builder>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>